import { FC, useContext } from 'react'

import { FeatureFlags } from '../../models/FeatureFlags'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import DviSingleInspectionCached from './DviSingleInspectionCached'
import { DviSingleInspectionNotCached } from './DviSingleInspectionNotCached'

const DviSingleInspection: FC = () => {
  const { featureFlags } = useContext(AppContext)
  if (featureFlags && featureFlags[FeatureFlags.ReplicacheDvi]) {
    return <DviSingleInspectionCached />
  }
  return <DviSingleInspectionNotCached />
}
export default DviSingleInspection
